import { render, staticRenderFns } from "./IndexLiquidity.vue?vue&type=template&id=139731ba&scoped=true&"
import script from "./IndexLiquidity.vue?vue&type=script&lang=js&"
export * from "./IndexLiquidity.vue?vue&type=script&lang=js&"
import style0 from "./IndexLiquidity.vue?vue&type=style&index=0&id=139731ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139731ba",
  null
  
)

export default component.exports